import { render, staticRenderFns } from "./RevisionPage.vue?vue&type=template&id=32c8f66a&scoped=true&"
import script from "./RevisionPage.vue?vue&type=script&lang=js&"
export * from "./RevisionPage.vue?vue&type=script&lang=js&"
import style0 from "./RevisionPage.vue?vue&type=style&index=0&id=32c8f66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c8f66a",
  null
  
)

export default component.exports